const BASIC_RECONNECTION_TIME = 1000;
const RECONNECTION_TIME_MULTIPLIER = 2;
const MAX_RECONNECTION_TIME = 64000;
import socketsEvents from '@/mixins/socketsEvents';
import { get } from 'vuex-pathify';
export default {
  mixins: [socketsEvents],
  data: () => ({
    currentReconnectionTime: null,
    dateOpened: undefined,
    manuallyClosed: false,
    socketConnection: undefined,
  }),
  computed: {
    token: get('authentication/token'),
    sessionId: get('authentication/sessionId'),
    socketConnectionState() {
      return this.socketConnection?.readyState;
    },
    wsDev() {
      return process.env.VUE_APP_WS_DEV === 'true';
    },
    wsUrl() {
      return `${process.env.VUE_APP_WS_URL || ''}`;
    },
  },
  methods: {
    socketClose() {
      this.manuallyClosed = true;
      this.socketConnection?.close();
    },
    socketConnect(reconnecting = false) {
      if ((this.currentReconnectionTime && !reconnecting) || !this.wsUrl) {
        if (this.wsDev && !this.wsUrl) console.log('[Websocket] Env variable VUE_APP_WS_URL is not set');
        return;
      }
      this.socketConnection = new WebSocket(
        `${this.wsUrl}/api/async/ws?session_id=${this.sessionId}&token=${this.token}`
      );
      this.socketConnection.onopen = () => {
        if (this.wsDev) console.log('[Websocket] Connection opened');
        this.dateOpened = this.$dayjs();
        this.manuallyClosed = false;
        this.currentReconnectionTime = null;
      };
      this.socketConnection.onmessage = e => {
        const data = JSON.parse(e.data);
        if (this.wsDev) console.log('[Websocket] Message:', data);
        if (data.event && Object.keys(this.socketEventsDict).includes(data.event)) {
          this[this.socketEventsDict[data.event]](data.data || {});
        } else if (data.event && this.wsDev) {
          console.log('[Websocket] Event unhandled');
        }
      };
      this.socketConnection.onerror = () => {
        if (this.wsDev) console.log('[Websocket] Connection error');
        this.manuallyClosed = false;
        const newReconnectionTime = this.currentReconnectionTime
          ? this.currentReconnectionTime * RECONNECTION_TIME_MULTIPLIER
          : BASIC_RECONNECTION_TIME;
        if (MAX_RECONNECTION_TIME && (MAX_RECONNECTION_TIME < newReconnectionTime || !newReconnectionTime)) {
          if (this.wsDev) console.log('[Websocket] Reconnection timeout');
          this.$store.set('snackbar/PUSH_ERROR!', {
            message: this.$i18n.t('errors.websocketReconnectionTimeout'),
          });
          this.currentReconnectionTime = null;
          this.manuallyClosed = true;
        } else {
          this.currentReconnectionTime = newReconnectionTime;
          if (this.wsDev)
            console.log(
              `[Websocket] Connection attempt will take place in ${this.currentReconnectionTime / 1000} second${
                this.currentReconnectionTime > 1000 ? 's' : ''
              }.`
            );
          setTimeout(() => {
            this.socketConnect(true);
          }, newReconnectionTime);
        }
      };
      this.socketConnection.onclose = () => {
        if (this.wsDev) {
          const duration = this.dateOpened ? this.$dayjs().diff(this.dateOpened, 's') : 0;
          this.dateOpened = undefined;
          if (duration) console.log(`[Websocket] Closed after ${duration}s of connection`);
        }
        if (!this.manuallyClosed && !this.currentReconnectionTime) {
          if (this.wsDev) console.log('[Websocket] Closed unexpectedly, trying to reconnect...');
          this.socketConnect();
        }
      };
    },
    socketSend({ data }) {
      if (this.socketConnectionState === 1) {
        this.socketConnection.send(JSON.stringify(data));
      } else if (this.socketConnectionState === 0) {
        setTimeout(() => {
          this.socketSend({ data });
        }, 1000);
      }
    },
    initSocket() {
      this.$root.$off('socket.connect');
      this.$root.$on('socket.connect', this.socketConnect);
      this.$root.$off('socket.send');
      this.$root.$on('socket.send', this.socketSend);
      this.$root.$off('socket.close');
      this.$root.$on('socket.close', this.socketClose);
    },
  },
};
